import { useState } from 'react';

import { AppEvents, Loader, useAppEventBus } from '@gasbi/shared';

import { palette } from '@/utils/theme';

export const GlobalLoadingScreen = () => {
  const [active, setActive] = useState<boolean>(true);

  useAppEventBus(AppEvents.LoadingStateEvent, isLoading =>
    setActive(isLoading),
  );

  if (!active) {
    return null;
  }

  return (
    <Loader
      sx={{
        top: 0,
        left: 0,
        '.MuiCircularProgress-progress': {
          stroke: palette.primary[500],
        },
      }}
    />
  );
};
